/* The sticky buy bar of a landing page (section vc-lbuy).
   It slides in once the hero (or the section named in the setting) has
   scrolled above the viewport, and steps aside at the closing section and
   while one of the theme's drawers (cart, menu, search) is open. The chip
   row switches between the analyses and the choice is kept for the visit.
   On a wide screen the arrow folds the bar into a pill with the price; the
   mobile layout keeps the whole bar and the stylesheet lifts it above the
   theme's menu bar. While hidden the bar is inert, so keyboard users skip
   it. The product pages have their own bar in vc-pd.js; the two never meet. */
(function () {
  'use strict';

  if (window.__vcSbxLoaded) return;
  window.__vcSbxLoaded = true;

  var MIN_KEY = 'vcSbxMin';
  var PICK_KEY = 'vcSbxPick';
  function stored(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function store(k, v) {
    try {
      if (v === null) sessionStorage.removeItem(k);
      else sessionStorage.setItem(k, v);
    } catch (e) {}
  }

  /* The theme marks an open drawer or modal on its overlay (painted, or
     aria-expanded), on the element itself (open), or by locking the page
     scroll; any of these counts. */
  function themeOverlays() {
    return Array.prototype.filter.call(document.querySelectorAll('overlay-element, .drawer, .x-modal'), function (el) { return !el.closest('.vc'); });
  }
  function overlayOpen(els) {
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.isConnected) continue;
      if (el.hasAttribute('open') || el.getAttribute('aria-expanded') === 'true') return true;
      if (el.tagName === 'OVERLAY-ELEMENT') {
        var cs = getComputedStyle(el);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05) return true;
      }
    }
    return getComputedStyle(document.documentElement).overflowY === 'hidden' || getComputedStyle(document.body).overflowY === 'hidden';
  }

  function bind() {
    var bar = document.querySelector('.vc [data-vc-sbx]');
    if (!bar || bar.getAttribute('data-vc-bound')) return;
    bar.setAttribute('data-vc-bound', '1');
    var root = bar.closest('.vc') || document;

    /* every section is its own stacking context, so a fixed bar left inside
       one would be painted over by the sections that follow; it moves to the
       end of the page inside a bare scope wrapper instead */
    if (root !== document && !(window.Shopify && Shopify.designMode)) {
      var wrap = document.createElement('div');
      wrap.className = root.className + ' vc-float';
      document.body.appendChild(wrap);
      wrap.appendChild(bar);
    }

    var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-vc-sbx-chip]'));
    var panels = Array.prototype.slice.call(bar.querySelectorAll('[data-vc-sbx-panel]'));
    var pill = bar.querySelector('[data-vc-sbx-open]');
    var pillPrice = bar.querySelector('[data-vc-sbx-pillprice]');
    var x = bar.querySelector('[data-vc-sbx-close]');

    function toneOf(el) {
      var m = (el.className || '').match(/tone-[a-z]+/);
      return m ? m[0] : '';
    }
    function pick(id, moveFocus, fromUser) {
      var live = null;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-vc-sbx-panel') === id;
        p.classList.toggle('is-live', on);
        if (on) live = p;
      });
      chips.forEach(function (c) {
        var on = c.getAttribute('data-vc-sbx-chip') === id;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
        if (on && moveFocus) c.focus();
        /* on a narrow phone the row scrolls, so a chip the visitor picked
           comes into view; never at load, where the bar is still off screen */
        if (on && fromUser && c.scrollIntoView) { try { c.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
      });
      if (live) {
        store(PICK_KEY, id);
        if (pill) {
          pill.className = pill.className.replace(/\s*tone-[a-z]+/g, '') + ' ' + toneOf(live);
          if (pillPrice) {
            var pr = live.querySelector('.sbx-price');
            pillPrice.textContent = pr ? pr.textContent : '';
          }
        }
      }
      return live;
    }
    chips.forEach(function (c, i) {
      c.addEventListener('click', function () { pick(c.getAttribute('data-vc-sbx-chip'), false, true); });
      c.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        var next = chips[(i + step + chips.length) % chips.length];
        pick(next.getAttribute('data-vc-sbx-chip'), true, true);
      });
    });
    /* the analysis chosen earlier in the visit, else the one the theme editor set */
    var want = stored(PICK_KEY);
    var start = null;
    panels.forEach(function (p) { if (p.classList.contains('is-live')) start = p.getAttribute('data-vc-sbx-panel'); });
    if (want && panels.some(function (p) { return p.getAttribute('data-vc-sbx-panel') === want; })) start = want;
    if (start) pick(start, false);

    /* folding keeps the bar in place: chips and card give way to the pill */
    function fold(on, moveFocus) {
      bar.classList.toggle('min', on);
      if (x) x.setAttribute('aria-expanded', on ? 'false' : 'true');
      if (pill) pill.setAttribute('aria-expanded', on ? 'false' : 'true');
      store(MIN_KEY, on ? '1' : null);
      if (!moveFocus) return;
      var live = bar.querySelector('.sbx-card.is-live');
      var to = on ? pill : (live && (live.querySelector('.sbx-btn') || live.querySelector('button, a')));
      if (to && to.offsetParent) to.focus();
    }
    if (x) x.addEventListener('click', function () { fold(true, true); });
    if (pill) pill.addEventListener('click', function () { fold(false, true); });
    fold(stored(MIN_KEY) === '1', false);

    /* what the bar waits for, and what ends it */
    var afterId = bar.getAttribute('data-vc-sbx-after');
    var after = afterId ? document.getElementById(afterId) : null;
    if (!after) after = document.querySelector('.vc-sec--lhero') || document.querySelector('.vc-sec');
    var endId = bar.getAttribute('data-vc-sbx-end');
    var end = endId ? document.getElementById(endId) : null;

    function show(on) {
      bar.classList.toggle('on', on);
      if (on) { bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    }
    if (!after) { show(false); return; }
    var overlays = themeOverlays();
    function check() {
      var r = after.getBoundingClientRect();
      var atEnd;
      if (end) atEnd = end.getBoundingClientRect().top < window.innerHeight;
      else atEnd = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 220);
      show(r.bottom < 0 && !atEnd && !overlayOpen(overlays));
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { check(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', check, { passive: true });

    /* drawers open and close without a scroll: watch them, and the page's
       scroll lock, and look again once their transition has run */
    if (window.MutationObserver) {
      var queued = false, later = 0;
      var mo = new MutationObserver(function () {
        if (!queued) {
          queued = true;
          requestAnimationFrame(function () { queued = false; check(); });
        }
        clearTimeout(later);
        later = setTimeout(check, 450);
      });
      var attrs = { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-expanded'] };
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
      mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
      overlays.forEach(function (el) { mo.observe(el, attrs); });
    }
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();

  /* the theme editor re-renders single sections, so re-bind on those events */
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:select', bind);
})();
